export default __webpack_public_path__ + "static/media/brackets_logo_colorful.f7848579.svg";